import * as React from 'react';

const FirstRunExperienceContext = React.createContext<{
    ProjectsCallout?: React.FunctionComponent<{ target: React.RefObject<Element> }>;
    ToolboxCallout?: React.FunctionComponent<{ target: React.RefObject<Element> }>;
}>({});

FirstRunExperienceContext.displayName = 'FirstRunExperienceContext';

export const FirstRunExperienceProvider = FirstRunExperienceContext.Provider;

export default function useFirstRunExperience() {
    return React.useContext(FirstRunExperienceContext);
}
